<script setup>
// import { ref } from 'vue';
import StockTable from "./Tables/StockTable.vue";
// import SawitBuahScheduleTable from "./Tables/SawitBuahScheduleTable.vue";
import ArgonInput from "@/components/ArgonInput.vue";
// import ArgonButton from "@/components/ArgonButton.vue";
import ArgonRadio from "@/components/ArgonRadio.vue";
</script>
<template>
<div class="py-4 container-fluid ">
    <div class="row">
        <div class="col-md-12">
            <div class="card">
                <div class="card-header pb-0">
                <h6>Stock</h6>
                </div>
                <div class="container-fluid">
                    <div class="row ">
                        <div class="col-md-3">
                            <label for="example-text-input" class="form-control-label text-danger">Item</label>
                            <select class="form-control" v-model="model.stock.item">
                                <option v-for="(itemObj,index) in model.stockItem" :key="index" :value="itemObj.item">
                                    {{ itemObj.item }} - {{ itemObj.supplier }}
                                </option>
                            </select>
                        </div>
                        <div class="col-md-3">
                            <label for="example-text-input" class="form-control-label text-danger">Quantity (Beg/Tong)</label>
                            <input class="form-control" v-model="model.stock.quantity" id="input_quantity" type="number" placeholder="1" />
                        </div>
                        <!-- <div class="col-md-3">
                            <label for="example-text-input" class="form-control-label">Quantity (Biji)</label>
                            <input class="form-control" v-model="model.sawitbuah.quantity" id="input_quantity" type="number" placeholder="200" />
                        </div> -->
                        <div class="col-md-3">
                            <label for="example-text-input" class="form-control-label">Capacity (Ml/Litre/KG)</label>
                            <input class="form-control" v-model="model.stock.capacity" id="input_capacity" type="text" placeholder="4 litre" />
                        </div>
                        <div class="col-md-3">
                            <label for="example-text-input" class="form-control-label">User</label>
                            <argon-input type="text" v-model="model.stock.usedby" id="input_usedby" placeholder="Zin Aun" />
                        </div>
                        <div class="col-md-2">
                            <label for="example-text-input" class="form-control-label">Status</label>
                            <div class="d-flex align-items-center">
                                <argon-radio id="inStock" name="stock-status" class="me-3" :checked="model.stock.status === 0" @click="model.stock.status = 0">In</argon-radio>
                                <argon-radio id="outStock" name="stock-status" :checked="model.stock.status === 1" @click="model.stock.status = 1">Out</argon-radio>
                            </div>
                            <!-- <select class="form-control" v-model="model.stock.status">
                                <option value="0">In</option>
                                <option value="1">Out</option>
                            </select> -->
                        </div>
                        <div class="col-md-3">
                            <label for="example-text-input" class="form-control-label">Remark</label>
                            <argon-input type="text" id="input_remark" v-model="model.stock.remark"  placeholder="Remark...." />
                        </div>
                    </div>
                    <div class="row">
                        <!-- <div class="col-md-10">
                            <button class="btn btn-info " @click="addStock" style="float: right;" id="btn_camera">Open Camera</button>
                        </div> -->
                        <div class="col-md-12">
                            <button class="btn btn-success " @click="addStock" style="float: right;" id="btn_add">Add</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="mt-4 row">
        <div class="col-md-12">
            <StockTable :key="componentKey" />
        </div>
    </div>
    <!-- <div class="mt-4 row">
        <div class="col-md-6">
            <SawitBuahScheduleTable :key="sawitBuahScheduleKey" />
        </div>
    </div> -->
</div>
</template>


<script>
import axios from 'axios';

export default {
  name:'stockCreate',
  data(){
    return {
        // image:'',
        componentKey: 0,
        // sawitBuahScheduleKey: 0,
    //   errorList: '',
      model:{
        stock:{
            item:'',
            status:0,
            quantity:'',
            capacity:'',
            usedby:'',
            remark:'',
        },
        stockItem:[]
      },
      blockList:[],
      selectedBlock:[],
      rawDate:'',
    }
  },
  mounted(){
    this.listAllStockProfile();
  },
  methods: {
    addStock(){
        // var mythis = this;
        // console.log(JSON.stringify(this.model.stock));
        axios.post('stock/addStock',this.model.stock)
            .then(res => {
                alert(res.data.message);
                // this.uploadImage();
                this.model.stock = {
                    item: this.stockItem[0].item,
                    status:'0',
                    quantity:'',
                    capacity:'',
                    usedby:'',
                    remark:''
                };
                this.componentKey += 1;
            }).catch(function (error){
                if(error.response){
                    if(error.response.status == 422){
                        alert('Error: Item, quantity and status is required!');
                    }
                }else if(error.request){
                    console.log(error.request);
                }else{
                    console.log('Error',error.message);
                }
            });
    },
    listAllStockProfile(){
        axios.get('stock/listAllStockProfile')
            .then(res => {
                this.model.stockItem = res.data.stockprofile;
                this.model.stock.item = res.data.stockprofile[0].item;
            }).catch(function (error){
                
              console.log('Error',error.message);
            });
    }
    
  },
}
</script>